import { Flex, Text } from "@simplybusiness/mobius";
import { Logo } from "../Logo";

type NoQuoteCardProps = {
  insurer: string;
  insurerLogo: string;
};

export const NoQuoteCard = ({ insurer, insurerLogo }: NoQuoteCardProps) => {
  return (
    <div
      role="listitem"
      className="mobius-quote-card__no-quote"
      data-testid="no-quote-card"
    >
      <div className="mobius-quote-card__no-quote-logo">
        <Logo logoPath={insurerLogo} alt={`${insurer} logo`} />
      </div>
      <Flex alignItems="center" className="">
        <Text variant="small">
          Based on the details you&apos;ve given us, this provider can&apos;t
          provide a quote
        </Text>
      </Flex>
    </div>
  );
};
